export default function SweetIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#A6E7F0"
        d="M11.678 11.929H8.225l-.95 1.087.74 6.133.814.85h2.302l.964-.413.667-5.658-1.084-2Zm2.91 0-1.162 1.186-1.177 6.186.81.699h1.168c.666 0 1.256-.43 1.462-1.063l1.702-5.245.547-1.763h-3.35Z"
      />
      <path
        fill="#6BD9E7"
        d="M12.901 15.926a1.705 1.705 0 0 0 2.908-1.205v-2.792h-1.22l-1.163 1.186-.533 2.802.008.009Zm-4.895 3.15.009.073.814.85h2.302l.964-.414.06-.51h-4.15Zm7.616 0h-3.33l-.043.225.81.699h1.168c.616 0 1.167-.368 1.41-.925h-.015Z"
      />
      <path
        fill="#F9F7F8"
        d="m14.588 11.929-.71 3.673L13.06 20H11.13l.44-6.308.106-1.763h2.911Z"
      />
      <path
        fill="#A6E7F0"
        d="m6.249 12.37-.818-.441H2.022l2.25 7.007A1.538 1.538 0 0 0 5.733 20H6.9l.696-1.8-1.348-5.83Z"
      />
      <path
        fill="#6BD9E7"
        d="M7.129 19.076c-.666 0-1.256-.43-1.462-1.064L3.714 11.93H2.022l2.25 7.007A1.538 1.538 0 0 0 5.733 20H6.9l.357-.924H7.13Z"
      />
      <path
        fill="#F9F7F8"
        d="M8.39 13.692 8.829 20H6.9l-1.175-6.308-.295-1.763h2.794l.165 1.763Z"
      />
      <path
        fill="#EFEDEF"
        d="M11.196 19.075 11.13 20h1.929l.172-.924h-2.036Zm-4.067 0c-.141 0-.28-.019-.41-.055L6.9 20h1.928l-.064-.924H7.129Z"
      />
      <path
        fill="#FDD79B"
        d="M17.469 10.556a1.607 1.607 0 0 1-.492 3.136H3.023a1.607 1.607 0 0 1-.522-3.126l4.833-.896h8.558l1.577.886Z"
      />
      <path
        fill="#EFEDEF"
        d="m11.678 11.93-.077 1.26c.28-.115.55-.258.8-.43v1.962c0 .455.178.883.5 1.205.232.232.52.388.832.457l.146-.781.71-3.673h-2.911Z"
      />
      <path
        fill="#FCCD7F"
        d="m17.469 10.556-1.577-.886H7.334l-3.932.729-.9.167a1.607 1.607 0 0 0 .52 3.126h2.25c-.37 0-.71-.3-.98-.655a.685.685 0 0 1 .566-1.1l.823.026a2.698 2.698 0 0 1 1.608.597c.76.611 1.716.948 2.691.948.863 0 1.711-.264 2.422-.749v.933h3.406v-1.771c0-.004.003-.007.007-.007l.466-.015a2.54 2.54 0 0 0 1.866-.914 1.607 1.607 0 0 0-.678-.43Z"
      />
      <path
        fill="#FFBEE7"
        d="M17.228 7.965a1.74 1.74 0 0 1-.973 3.14l-.466.016a.8.8 0 0 0-.774.8v2.8a.91.91 0 1 1-1.82 0v-2.325a.61.61 0 0 0-.987-.482l-.035.028a3.493 3.493 0 0 1-4.386 0 3.495 3.495 0 0 0-2.08-.771l-2.002-.065a1.739 1.739 0 0 1-.972-3.141l1.399-1.026c.276-.203.487-.483.605-.805a4.619 4.619 0 0 1 2.636-2.71l.782-.31 1.6-.419 2.05.419.782.31a4.623 4.623 0 0 1 2.636 2.71 1.745 1.745 0 0 0 .606.805l1.399 1.026Z"
      />
      <path
        fill="#FE93D3"
        d="M7.522 7.533a.297.297 0 0 1-.192-.07l-.375-.317a.298.298 0 0 1 .383-.455l.376.316a.298.298 0 0 1-.192.526Zm2.233-.159a.298.298 0 0 1-.258-.445l.225-.395a.298.298 0 0 1 .517.295l-.225.395a.298.298 0 0 1-.26.15ZM12.62 6.15a.298.298 0 0 1-.297-.298v-.336a.298.298 0 0 1 .595 0v.336a.298.298 0 0 1-.298.298Zm-.553 1.62a.297.297 0 0 1-.221-.098l-.356-.395a.298.298 0 1 1 .443-.398l.355.395a.298.298 0 0 1-.221.497Zm-.27 1.901h-.56a.298.298 0 1 1 0-.595h.56a.298.298 0 1 1 0 .595ZM8.61 9.43a.298.298 0 0 1-.239-.475l.22-.296a.298.298 0 1 1 .478.354l-.22.296a.297.297 0 0 1-.24.12Zm-2.534-.187a.297.297 0 0 1-.153-.042l-.35-.21a.298.298 0 0 1 .306-.51l.35.209a.298.298 0 0 1-.153.553Zm7.889-.426a.298.298 0 0 1-.26-.442l.197-.356a.298.298 0 1 1 .52.29l-.197.355a.297.297 0 0 1-.26.153Z"
      />
      <path
        fill="#FEAEE1"
        d="M14.989 14.81a.907.907 0 0 1-.91-.91v-2.312a.611.611 0 0 0-.988-.496c-.01.01-.022.019-.034.028-.084.067-.17.13-.259.189a1.757 1.757 0 0 1-2.073-.092 3.496 3.496 0 0 0-2.08-.77l-2.002-.065A1.739 1.739 0 0 1 5.67 7.24l1.4-1.025c.276-.204.487-.483.605-.806l.005-.015a.658.658 0 0 1 .959-.332c.392.236.85.372 1.341.372A2.615 2.615 0 0 0 12.526 3.4l-.72-.286-2.05-.419-1.601.419-.782.31a4.617 4.617 0 0 0-2.636 2.71 1.742 1.742 0 0 1-.605.805l-1.4 1.026a1.74 1.74 0 0 0 .973 3.14l2.002.066a3.499 3.499 0 0 1 2.08.77 3.493 3.493 0 0 0 4.386 0l.031-.024.004-.003a.608.608 0 0 1 .881.137.632.632 0 0 1 .107.359v2.312a.907.907 0 0 0 .91.91.91.91 0 0 0 .905-.824l-.022.001Z"
      />
      <path
        fill="#EE6161"
        d="M9.98 4.64a1.817 1.817 0 1 0 0-3.634 1.817 1.817 0 0 0 0 3.634Z"
      />
      <path
        fill="#D1A08F"
        d="M10.219 2.802a.298.298 0 0 1-.298-.298v-.531c0-.681.265-1.321.747-1.803l.083-.083a.298.298 0 1 1 .421.421l-.083.083a1.94 1.94 0 0 0-.572 1.382v.531a.298.298 0 0 1-.298.298Z"
      />
    </svg>
  );
}
